import { parseEntity } from '@/shared/converters/commonConverters';
import { parseMoment } from '@/shared/converters/dateConverters';
import Outlet from '@/shared/models/Outlet';
import Vehicle from '@/vehicle/models/Vehicle';
import Keydrop from '../models/Keydrop';

const SCHEMA = {
  keyDropOn: (data: any) => parseMoment(data.keyDropOn),
  locationDescription: 'locationDescription',
  outlet: (data: any) => Outlet.withData({ id: data.moboOutletId, abbreviation: data.moboOutletAbbreviation, description: data.moboOutletDescription }),
  vehicle: (data: any) => Vehicle.withData({ registrationNumber: data.registrationNumber }),
  mobileNumber: 'mobileNumber',
  emailAddress: 'emailAddress',
  customerName: 'customerName',
  reasonOfVisit: 'reasonOfVisit',
  parkingLocation: 'parkingLocation',
};

export function parseKeydrop(data: any): Keydrop | null {
  return parseEntity(data, SCHEMA, Keydrop);
}
